module.exports = __webpack_public_path__ + "img/plus.529d8087.svg";